





























import Vue from 'vue';
import { AdgroupFormData, CampaignFormData, FullNormalFormData } from '@tt4b/ttam-enums';
import { defineComponent, ref, PropType, nextTick, computed } from '@vue/composition-api';
import ImageUploaderSlipContent from './slip-content.vue';

const name = 'ttam-material-image-upload';

export default defineComponent({
  name,
  components: { ImageUploaderSlipContent },
  props: {
    topHeight: { type: Number },
    width: { type: String, default: '1080px' },
    showClose: { type: Boolean, default: true },
    showMask: { type: Boolean, default: false },
    limit: { type: Number, default: 20 },
    fileAccept: { type: String, default: '', require: true },

    /** 是否需要多选 */
    multiple: { type: Boolean, default: true },
    /** 支持的图片类型，为空则为不限制 */
    imageModeSupport: { type: Array, default: () => [] },
    /** 是否需要版位校验 */
    inventoryCheck: { type: Boolean, default: true },
    /** 确认事件，如果传入确认事件，则不会调用默认 */
    confirmCallback: {
      type: Function as PropType<(param: any) => void>,
      default: undefined,
    },
    adgroupData: {
      required: true,
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    campaignData: {
      required: true,
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    creativeData: {
      required: true,
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
  },

  setup(props, ctx) {
    const slipDirection = ref(document.dir === 'rtl' ? 'slide-left' : 'slide-right');

    const slipVisible = ref(false);
    const open = () => (slipVisible.value = true);
    const close = () => {
      slipVisible.value = false;
      ctx.emit('close');
    };

    const imageUploaderSlipNode = ref();
    const clearFiles = () => imageUploaderSlipNode.value?.clearFiles();
    const cancelUpload = () => imageUploaderSlipNode.value?.cancelUpload();

    const firstOpen = () => {
      clearFiles();
      nextTick(() => open());
    };

    function reUpload(directReUpload = false) {
      clearFiles();
      imageUploaderSlipNode.value?.reUpload(directReUpload);

      // 如果非直接上传
      if (!directReUpload) {
        open();
      }
    }

    function onConfirm(info) {
      ctx.emit('confirm', info);
    }

    /** 选中事件 */
    function onProgress(infoObj) {
      ctx.emit('progress', infoObj);
    }

    const _top = computed(() => props.topHeight ?? Vue.prototype.$TTAMUI?.headerHeight);

    function onStartUpload(files) {
      ctx.emit('start-upload', files);
    }

    return {
      name,
      imageUploaderSlipNode,
      slipVisible,
      slipDirection,
      _top,
      close,
      open,
      firstOpen,
      reUpload,
      cancelUpload,
      onProgress,
      onConfirm,
      onStartUpload,
    };
  },
});
